import { Box, Card } from '@mui/material'

import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import WTypography from 'Components/whiteTypography'
import { Bar } from 'react-chartjs-2'

const optionsbar = {
  indexAxis: 'y',
  aspectRatio: 1.05,

  elements: {
    bar: {
      borderWidth: 2,
    },
  },
  responsive: true,
  scales: {
    x: {
      ticks: {
        color: 'white',
      },
      grid: {
        color: 'rgba(255,255,255,0.1)',
      },
    },
    y: {
      ticks: {
        color: 'white',
      },
      grid: {
        color: 'rgba(255,255,255,0.1)',
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      display: false,
      color: 'white',
      formatter: (val, ctx) => ctx.chart.data.labels[ctx.dataIndex],
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem) {
          return tooltipItem.yLabel
        },
      },
    },
  },
}
function Opportunite({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  // LAP-733 (GE022): chart labels re-evaluate on locale change
  const data = useMemo(
    () => ({
      labels: [
        t('professionnelle.statusSaved'),
        t('professionnelle.statusSent'),
        t('professionnelle.statusAccepted'),
        t('professionnelle.statusRefused'),
      ],

      datasets: [
        {
          data: oldData.data,
          borderColor: ['yellow', 'green', 'green', 'red'],
          backgroundColor: ['yellow', 'green', 'green', 'red'],
          borderWidth: 1,
          barThickness: 15,
        },
      ],
    }),
    [t, oldData.data],
  )

  return (
    <>
      <Card className="dashboard_card__root1" sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box className="dashboard_card__header1 no-drag">
          <WTypography component={'span'} variant="h6">
            {t('professionnelle.opportunite') /* LAP-733 (GE022) */}
          </WTypography>
          <WTypography component={'span'} variant="h6">
            {oldData.total}
          </WTypography>
        </Box>
        <Box className="dashboard_card__header1">
          <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
            {t('professionnelle.opportuniteByStatus') /* LAP-733 (GE022) */}
          </WTypography>
        </Box>
        <Box mt={1} minWidth={3} mb={1} height={'100%'}>
          <Bar data={data} options={optionsbar} />
        </Box>
      </Card>
    </>
  )
}

export default Opportunite
